import React, { useState, useEffect } from "react";
import IDatepickerProps from "./IDatePickerProps";
import ReactPicker from "react-datepicker";
import { FormHelperText, FormLabel } from "@hid-galaxy-ui/galaxy-react/components/FormElement";
import classNames from "classnames";
import "react-datepicker/dist/react-datepicker.css";
import DateRange from "./DateRange";
import CustomHeader from "./CustomHeader";

const DatePicker = (props: IDatepickerProps) => {
  const {
    label,
    onChange,
    minDate,
    maxDate,
    format,
    placeholder,
    isError,
    isRange,
    value,
    showTimeSelect,
    showTimeSelectOnly,
    timeIntervals,
    portalId,
    helperText,
    id,
    isDisabled,
    isClearable,
    isRequired = false,
    showYearMonthDropdown = false,
    theme = "light",
    ...otherProps
  } = props;

  const [selectedDate, setSelectedDate] = useState<Date | null>();

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);

  useEffect(() => {
    if (isRange) {
      Array.isArray(value) &&
        setDateRange(value as unknown as [Date | null, Date | null]);
    } else {
      setSelectedDate(value as Date | null);
    }
  }, [value]);

  const handleDateChange = (date: [Date | null, Date | null] | Date | null) => {
    if (isRange && Array.isArray(date)) {
      setDateRange(date as unknown as [Date | null, Date | null]);
      onChange(date);
    } else {
      setSelectedDate(date as Date | null);
      onChange(date);
    }
  };

  const [startDate, endDate] = dateRange;
  return (
    <div
      className={classNames(
        "hid-form-element hid-form-group",
        showTimeSelectOnly
          ? "react-datepicker__time"
          : "react-datepicker__date",
        {
          "hid-form-element--error": isError,
          "hid-form-element--disabled": isDisabled,
        }
      )}
      data-testid="date-picker"
    >
      {label && (
        <FormLabel htmlFor={id} isRequired={isRequired}>
          {label}
        </FormLabel>
      )}
      <>
        {!isRange ? (
          <>
            <ReactPicker
              id={id}
              className={classNames("hid-form-element__control", {
                "hid-form-element__control--dark": theme === "dark",
              })}
              dateFormat={format ? format : undefined}
              selectsRange={isRange}
              startDate={isRange ? startDate : null}
              endDate={isRange ? endDate : null}
              selected={selectedDate}
              onChange={handleDateChange}
              {...(portalId && { portalId: portalId })}
              placeholderText={placeholder}
              showTimeSelect={showTimeSelect}
              showTimeSelectOnly={showTimeSelectOnly}
              timeIntervals={timeIntervals}
              strictParsing={true}
              disabled={isDisabled}
              autoComplete="off"
              isClearable={isClearable}
              minDate={minDate}
              maxDate={maxDate}
              {...(showYearMonthDropdown && {
                renderCustomHeader: (props) => (
                  <CustomHeader
                    {...props}
                    minDate={minDate}
                    maxDate={maxDate}
                  />
                ),
              })}
              {...otherProps}
            />
          </>
        ) : (
          <DateRange isRange={true} {...props} />
        )}
      </>

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </div>
  );
};

export default DatePicker;
